import InstructionIcon from 'assets/img/icons/instruction.svg';
import Button from 'components/_parts/atoms/button';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import {
  HIT_WORKER_TYPE_CREATE,
  HIT_WORKER_TYPE_UPDATE,
} from 'redux/actions/wla';
import styled from 'styled-components';
import * as Yup from 'yup';
import './index.scss';
import Tab from 'components/_parts/atoms/tab';
import { useCopCreateMutation, useCopUpdateMutation } from 'components/company/hooks/useCompany';
import InitialValues from './initialValues';
import validationSchema from '../../activity/modal/validationSchema';
import ValidationSchema from './validationSchema';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonInfo = styled(Button)`
  width: 100%;
  width: fit-content;
  height: 40px;
  min-width: 147px;
  border: 1px solid #3d5afe;
  background-color: #ffffff;
  color: #3d5afe;
  padding: 12px 16px;
  column-gap: 10px;
`;

function WorkerType(props) {
  const dispatch = useDispatch();
  const createCopMutation = useCopCreateMutation();
  const updateCopMutation = useCopUpdateMutation();
  const { t } = props;
  const selectedTab = (key, onSubmit) => {
    switch (key) {
      case 0:
      case 'integer':
        if (onSubmit) return 'integer';
        return 0;
      case 1:
      case 'boolean':
        if (onSubmit) return 'boolean';
        return 1;
      case 2:
      case 'date':
        if (onSubmit) return 'date';
        return 2;
      case 3:
      case 'character':
        if (onSubmit) return 'character';
        return 3;
      case 4:
      case 'text':
        if (onSubmit) return 'text';
        return 4;
      case 5:
      case 'long_text':
        if (onSubmit) return 'long_text';
        return 5;

      default:
        break;
    }
  };
  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: ValidationSchema({ t }),
    onSubmit: async (values) => {
      try {
        if (props.typeForm === 'edit') {
          await updateCopMutation.mutateAsync({
            data: {
              ...formik.values,
              company_cust_param_id: props?.data?.company_cust_param_id,
              status: 'active',
              input_type: selectedTab(values.input_type, true),
            },
            id: props.ids,
          });
        } else if (props.typeForm === 'create') {
          await createCopMutation.mutateAsync({
            ...formik.values,
            input_type: selectedTab(values.input_type, true),
          });
        } else {
          await updateCopMutation.mutateAsync({
            data: {
              ...formik.values,
              company_cust_param_id: props?.data?.company_cust_param_id,
              status: 'inactive',
              input_type: selectedTab(values.input_type, true),
            },
            id: props.ids,
          });
        }
        props.setShowModal(false);
        formik.resetForm();
      } catch (error) {
        props.funcModal(false);
        formik.resetForm();
      }
    },
    onChange: (e) => {
      formik.setFieldValue(e.target.name, e.target.value);
    },
  });
  useEffect(() => {
    if (props.typeForm === 'edit') {
      formik.setValues({
        title: props?.data?.title,
        input_type: props?.data?.input_type,
      });
    } else {
      formik.setValues({
        title: '',
        input_type: '',
      });
    }
  }, [props.data, props.type]);

  useEffect(() => { }, [props.typeForm, props.modal, props.tab]);
  const handleChange = (e) => {
    formik.setFieldValue('input_type', e);
  };
  return (
    <>
      {props.modal
        && createPortal(
          <>
            <FullScreenOverlay className="cs_modal-bg" />
            <div
              className="cs_modal-container d-flex justify-content-between flex-column"
              ref={props.innerRef}
            >
              <Label
                className="text-center"
                typeLabel="label_modal"
                style={{
                  fontSize: '16px',
                }}
              >
                {`${props?.typeForm === 'edit' ? t('org.structure_view.modal.edit') : t('org.structure_view.modal.add')} ${t('company.custom_parameter')}`}
              </Label>
              <div className="cs_modal-worktype">
                <div>
                  <Input
                    isError={
                      formik.touched.title && Boolean(formik.errors.title)
                    }
                    validateMessage={formik.errors.title}
                    type="text"
                    name="title"
                    placeholder={t('company.parameter_name')}
                    value={formik.values.title}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="text-center">
                  <Label>{t('biz_process.process_library.type')}</Label>
                </div>
                <div>
                  <Tab
                    style={{
                      display: 'grid',
                      gridTemplateColumns: '1fr 1fr',
                      rowGap: '8px',
                    }}
                    tab={selectedTab(formik.values.input_type)}
                    data={[
                      {
                        id: 1,
                        name: 'Integer',
                      },
                      {
                        id: 2,
                        name: 'Boolean(Y/N)',
                      },
                      {
                        id: 3,
                        name: 'Date',
                      },
                      {
                        id: 4,
                        name: 'Character',
                      },
                      {
                        id: 5,
                        name: 'Text',
                      },
                      {
                        id: 6,
                        name: 'Long Text (>255)',
                      },
                    ]}
                    setValues={handleChange}
                    typeTab="button"
                  />
                  {formik.errors.input_type && formik.touched.input_type && (
                    <Label className="error d-block text-left maxWidth250px label_error">
                      {formik.errors.input_type}
                    </Label>
                  )}
                </div>
              </div>
              <div className="d-flex flex-row justify-content-end">
                <ButtonMod
                  func={(e) => {
                    formik.handleSubmit(e);
                    setTimeout(() => {
                      props.funcId(null);
                    }, 1000);
                  }}
                >
                  {t('board.save')}
                </ButtonMod>
              </div>
            </div>
          </>,
          document.getElementById('custom_org_list'),
        )}
    </>
  );
}

export default WorkerType;
